import React, {memo, useCallback, useMemo} from 'react';
import PropTypes from 'prop-types';
import SelectElementCmp from '@/utils/SelectElementCmp';
import {OperatorFilter, TermFilter} from '@dofleini/query-builder';
import RegistersApiService from '@/modules/registers/services/RegistersApiService';

const SelectAreaAccessRegisters = ({value, onChange, defaultValue, form, fieldKey, translation}) => {

  const areaAccess = useMemo(() => {
    const temp = form.getFieldValue('registersAccess');
    return temp[fieldKey]?.areaAccess || '';
  }, [form, fieldKey]);

  const category = useMemo(() => {
    const temp = form.getFieldValue('registersAccess');
    return temp[fieldKey]?.category || '';
  }, [form, fieldKey]);

  const space = useMemo(() => {
    return form.getFieldValue('space');
  }, [form]);

  const filterRegisters = useMemo(() => {
    const categoryFilter = new TermFilter({field: 'category', value: category, objectId: true}).toQuery();
    const areaAccessFilter = new TermFilter({field: 'areaAccess', value: areaAccess, objectId: false}).toQuery();
    if (category) {
      return new OperatorFilter({type: 'AND', filters: [
        categoryFilter,
        areaAccessFilter,
      ]});
    }
    return areaAccessFilter;
  }, [areaAccess, category]);

  const onChangeValues = useCallback((value) => {
    const temp = form.getFieldValue('registersAccess');
    if (!temp[fieldKey]) {
      temp[fieldKey] = {};
    }
    temp[fieldKey].registers = value;
    form.setFieldsValue({registersAccess: temp});
    onChange && onChange(temp);
  }, [fieldKey, form, onChange]);

  const currentValue = useMemo(() => {
    return Array.isArray(value) ? value.map(v => v._id || v) : undefined;
  }, [value]);

  return (
    <SelectElementCmp
      queryKey={`areaAccess-registers-select-${fieldKey}-${category}`}
      key={`areaAccess-registers-select-${fieldKey}-${category}`}
      service={RegistersApiService}
      customMethod={'/ms-registry/api/registers/search-for-users-access'}
      filters={filterRegisters}
      value={currentValue || []}
      onChange={onChangeValues}
      defaultValue={defaultValue}
      queryConfig={{ refetchOnWindowFocus: false }}
      nameToShow={'name'}
      className="custom-select w-full"
      mode={'multiple'}
      maxTagCount={'responsive'}
      optionLabelProp="title"
      placeholder={translation('placeholderSelectServices')}
      allOption={{ show: true, label: translation('selectAllRegisters'), value: 'all', excludeValueFromFilters: true}}
      additionalParams={{
        all: true,
        forceSize: true,
        size: 1000,
        useProjections: true,
        projections: {
          name: 1,
        },
        userSpace: space?._id
      }}
    />
  );
};

SelectAreaAccessRegisters.propTypes = {
  value: PropTypes.string || PropTypes.object,
  onChange: PropTypes.func,
  service: PropTypes.string,
  defaultValue: PropTypes.any,
  setTemplates: PropTypes.func,
  form: PropTypes.any,
  fieldKey: PropTypes.any,
  translation: PropTypes.func
};
SelectAreaAccessRegisters.defaultProps = {
  entity: {},
};

export default memo(SelectAreaAccessRegisters);

const AreaAccessRegistersView = ({value}) => {

  return (
    <div>
      {value?.name || 'N/A'}
    </div>
  );
};

AreaAccessRegistersView.propTypes = {
  value: PropTypes.string
};

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Code component in a table cell
 * @param {String} text this is the value of the dataIndex of the table
 * */
export const renderAreaAccessRegisters = (text) => {
  return (
    <AreaAccessRegistersView value={text}/>
  );
};
